module.exports = __webpack_public_path__ + "static/media/p9.cc3e9f89.jpeg";